<template>
  <b-container fluid>
    <!-- <b-card-title>{{ result.onderhoud.naam }} {{ result.arguments.jaar }}</b-card-title> -->
      
    <b-pagination 
      
      v-model="currentPage"
      :total-rows="filteredService.length"
      :per-page="30"
      limit="10" 
      class="my-3"
    />
    <b-table 

      ref="status_table"
      :current-page="currentPage"
      :items="filteredService"
      :fields="[
        {key: 'i',label: 'Id'},
        {key: 'u',label: 'Unit'},
        {key : 'r',label: 'Responsetijd'},
        {key : 'g',label: 'Oplostijd'},
        {key : 'm',label: 'Stilstand'},
        {key : 'a',label: 'Datum'},
        {key : 'p',label: 'Prestatie'},
        {key : 't',label: 'Type'},
        {key : 'd',label: 'Datapunt'},
        {key : 'c',label: 'Categorie'},
        {key : 'o',label: 'Onderhoud'},
      ]"
      selectable
      bordered  
      striped
      per-page="30" 
      dark
      responsive
      small
      @row-clicked="(record,index) => record._showDetails = !record._showDetails"
    >
      <template #cell(d)="data">
        {{ data.item.d.length }}
      </template>
      <template #cell(a)="data">
        {{ moment(data.item.a).format('lll') }}
      </template>
      <template #cell(t)="data">
        {{ data.item.t }}
      </template>
      <template #cell(c)="data">
        <b-select 
          v-model="data.item.c" 
          :options="['TO','VA','OG','NB','EX','LM',{value:null,text:'null'}]"
          small
          @input="(value) => changeStatus(data.item.i,value,'categorie')"
        />
      </template>
      <template #cell(p)="data">
        <b-checkbox 
          v-model="data.item.p"
          :value="true"
          size="lg"  
          @input="(value) => changeStatus(data.item.i,value,'voorPrestatie')"
        />
      </template>
      <template #row-details="data">
        <div>
          <b-badge
            v-for="(d,index) in data.item.d" 
            :key="index" 
            class="m-2"
            variant="default text-lg"
          >
            <b-avatar> T{{ index+1 }}</b-avatar>
            {{ moment(d).format('lll') }}
          </b-badge> 
        </div>
      </template>
    </b-table>
    <b-pagination 
      v-model="currentPage"
      :total-rows="filteredService.length"
      :per-page="30"
      limit="10" 
      class="my-3"
    />
  </b-container>
</template>
<script>
import { serviceMixin } from '@/mixins/serviceMixin.js';
    export default {
        name: 'StatusTable',
        components: {},
        mixins: [serviceMixin],
        props: {
            service: {
                type: Array,
                default: () => []
            },
            prestatie: {
                type: Boolean,
                required: false,
                default: true,
            }
        },
        data() {
            return  {
                currentPage: 1,
            }
        },
        computed: {
          filteredService: function() {
            return this.service.filter((s) => (this.prestatie === false || s.p === this.prestatie));
          }
        },
        watch: {},
        mounted () {
            
        },
        methods: {
            changeStatus(id,value,field) {
                var endpoint = `status/${id}/${field}`;
                var data = {};
                data[field] = value; 
                this.put(endpoint,data ).then((response) => console.log(response));
            },
        },
              
    }
</script>